import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const BudgetsPage = lazy(() => import('./BudgetsPage'));
const RevisionDetailPage = lazy(() => import('./RevisionDetailPage'));

const routes: RouteObject[] = [
  { path: '/budgets', element: <Guard any={['budget.read']}><BudgetsPage /></Guard> },
  // the approvals inbox links revisions as /budgets/revisions/<number>; /budget-revisions/<id> is the API-style alias
  { path: '/budgets/revisions/:id', element: <Guard any={['budget.read']}><RevisionDetailPage /></Guard> },
  { path: '/budget-revisions/:id', element: <Guard any={['budget.read']}><RevisionDetailPage /></Guard> },
];
export default routes;
